// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transparent-list {
  background: transparent;
  padding: 16px;
}

.transparent-item {
  --background: rgba(255, 255, 255, 0.15);
  --border-color: transparent;
  margin: 8px 0;
  border-radius: 8px;
  --color: var(--ion-color-light);
}

.footer-list {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding-bottom: 20px;
  margin-top: 32px;
}

.custom-toolbar {
  --background: var(--ion-color-light);
  --color: var(--ion-color-dark);
}

.back-icon {
  font-size: 24px;
  color: var(--ion-color-dark);
}

.page-title {
  font-size: 20px;
  font-weight: 500;
}

.profile-section {
  margin: 16px 0;
  --background: transparent;
}

.profile-icon {
  height: 60px;
  width: 60px;
  color: var(--ion-color-medium);
}

.profile-name {
  font-weight: bold;
  font-size: 18px;
  color: var(--ion-color-dark);
}

.profile-email {
  font-size: 14px;
  color: var(--ion-color-medium);
}

.section-title {
  margin-top: 20px;
  --background: transparent;
}

.section-title ion-title {
  font-size: 16px;
  font-weight: 500;
  color: var(--ion-color-light);
}

.menu-item {
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 56px;
  --color: var(--ion-color-light);
}

.menu-icon {
  color: var(--ion-color-light);
  font-size: 24px;
  margin-right: 16px;
}

ion-label {
  color: var(--ion-color-light);
  font-size: 16px;
  font-weight: 500;
}

ion-icon[slot=end] {
  color: var(--ion-color-light);
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/account/account.component.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,aAAA;AACF;;AAEA;EACE,uCAAA;EACA,2BAAA;EACA,aAAA;EACA,kBAAA;EACA,+BAAA;AACF;;AAEA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;AACF;;AAEA;EACE,oCAAA;EACA,8BAAA;AACF;;AAEA;EACE,eAAA;EACA,4BAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,yBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,8BAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,4BAAA;AACF;;AAEA;EACE,eAAA;EACA,8BAAA;AACF;;AAEA;EACE,gBAAA;EACA,yBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;AACF;;AAEA;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,+BAAA;AACF;;AAEA;EACE,6BAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,6BAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,6BAAA;EACA,eAAA;AACF","sourcesContent":[".transparent-list {\r\n  background: transparent;\r\n  padding: 16px;\r\n}\r\n\r\n.transparent-item {\r\n  --background: rgba(255, 255, 255, 0.15);\r\n  --border-color: transparent;\r\n  margin: 8px 0;\r\n  border-radius: 8px;\r\n  --color: var(--ion-color-light);\r\n}\r\n\r\n.footer-list {\r\n  position: fixed;\r\n  bottom: 0;\r\n  width: 100%;\r\n  padding-bottom: 20px;\r\n  margin-top: 32px;\r\n}\r\n\r\n.custom-toolbar {\r\n  --background: var(--ion-color-light);\r\n  --color: var(--ion-color-dark);\r\n}\r\n\r\n.back-icon {\r\n  font-size: 24px;\r\n  color: var(--ion-color-dark);\r\n}\r\n\r\n.page-title {\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n}\r\n\r\n.profile-section {\r\n  margin: 16px 0;\r\n  --background: transparent;\r\n}\r\n\r\n.profile-icon {\r\n  height: 60px;\r\n  width: 60px;\r\n  color: var(--ion-color-medium);\r\n}\r\n\r\n.profile-name {\r\n  font-weight: bold;\r\n  font-size: 18px;\r\n  color: var(--ion-color-dark);\r\n}\r\n\r\n.profile-email {\r\n  font-size: 14px;\r\n  color: var(--ion-color-medium);\r\n}\r\n\r\n.section-title {\r\n  margin-top: 20px;\r\n  --background: transparent;\r\n}\r\n\r\n.section-title ion-title {\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  color: var(--ion-color-light);\r\n}\r\n\r\n.menu-item {\r\n  --padding-start: 16px;\r\n  --padding-end: 16px;\r\n  --min-height: 56px;\r\n  --color: var(--ion-color-light);\r\n}\r\n\r\n.menu-icon {\r\n  color: var(--ion-color-light);\r\n  font-size: 24px;\r\n  margin-right: 16px;\r\n}\r\n\r\nion-label {\r\n  color: var(--ion-color-light);\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n}\r\n\r\nion-icon[slot=\"end\"] {\r\n  color: var(--ion-color-light);\r\n  font-size: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
